//RELEASE CANARY (build estático, nginx dedicado :8445 -> /api/ -> dev-api isolado; .php -> dev-php)
/* export const BASE_URL = "https://localhost:8445/api";
export const APP_URL = "https://localhost:8445";
export const URL_RETORNO = "https://localhost:8445";
export const CLICKSIGN_ENDPOINT = "https://sandbox.clicksign.com"; */

//Clicksign assinatura incorporada — deve apontar para o MESMO ambiente do backend.
//dev/sandbox: https://sandbox.clicksign.com | produção: https://app.clicksign.com

//production
export const BASE_URL = "https://sistema.spprod.com.br/api";
export const APP_URL = "https://sistema.spprod.com.br";
export const URL_RETORNO = "https://sistema.spprod.com.br";
export const CLICKSIGN_ENDPOINT = "https://app.clicksign.com";

//production (IP)
/* export const BASE_URL = "http://187.32.210.82:3737";
export const APP_URL = "http://187.32.210.82";
export const URL_RETORNO = "http://sistema.spprod.com.br"; */

//dev (API direta, sem nginx)
/* export const APP_URL = "http://localhost";
export const BASE_URL = "http://localhost:3737";
export const URL_RETORNO = "http://localhost:3000"; */
/* export const APP_URL = "http://192.168.1.5";
export const BASE_URL = "http://192.168.1.5:3737";
export const URL_RETORNO = "http://192.168.1.5:3000"; */

export const BASE_URL_BANK = "https://mpag.bb.com.br/site/mpag/";
export const ALBUM_LIMIT = 50;
export const FILTER_FORMATURA = 199;
// Taxa fixa do boleto agora vem da config (cfgtaxaboleto, aplicada no backend ao
// registrar via API do BB). Mantido em 0 no front p/ o valor exibido bater com o
// boleto emitido. Nao somar taxa aqui.
export const TAXA_BOLETO = 0;
// Boleto liga/desliga agora vem do BACKEND: config.cfgboletoapiativo (0=oculta o
// botão de gerar boleto; 1=exibe). GeraCobrancas consome via getBoletoApiAtivo()
// (/pagamentos/configcobranca). Não afeta 2ª via de boleto já registrado. Para
// reabrir/fechar boleto, o admin muda o flag no banco — sem rebuild do front.
export const ID_CONV = "322122";
export const REF_TRAN = "3210965";
export const TP_PAGAMENTO = "2";
export const TP_VIA_2 = "21";
export const INDICADOR_PESSOA = "1";
export const TP_DUPLICATA = "DM";

export const SEDEX_PADRAO = 30;

export const PARCELA_MINIMA = 5;
export const MAX_PARCELAS = 12;
export const MAX_SEM_JUROS = 1;

// Chave Pix (chave/titular/cidade) NÃO é mais constante aqui: vem da API por
// produtora da formatura — /perfil/cadastro (portal) e /contrato/condicao
// (autocadastro). Consumida em GeraPix/GeraPagamento/GeraCobrancas/Success.
export const EMAIL_FINANCEIRO = "financeiro@spprod.com.br";
export const RAZAO_SOCIAL = "SP Produtora Ltda.";
export const RAZAO_CNPJ = "CNPJ: 57.979.527/0001-27";
